import { getHourAndMinute, getTimestamp, getTimestampFromDate, HOUR_MINUTES, TIME_GAP, } from './TimePickerHelper';
var getDateBeginning = function () {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
};
/**
 * get target time boundary, what time is nearest time with that timeGap
 */
var TimeBoundary = /** @class */ (function () {
    function TimeBoundary(value, direction, timeGap) {
        this.value = value;
        this.timeGap = timeGap;
        this._hour = undefined;
        this._minute = undefined;
        this._date = undefined;
        this.timestamp = 0;
        if (value) {
            if (direction === 'after') {
                this.getAfterNearTime();
            }
            else {
                this.getBeforeNearTime();
            }
            this.date = new Date(getDateBeginning().setHours(this.hour, this.minute, 0, 0));
        }
    }
    Object.defineProperty(TimeBoundary.prototype, "hour", {
        get: function () {
            return this._hour;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeBoundary.prototype, "minute", {
        get: function () {
            return this._minute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeBoundary.prototype, "date", {
        get: function () {
            return this._date;
        },
        set: function (value) {
            if (value) {
                this.timestamp = getTimestampFromDate(value);
            }
            this._date = value;
        },
        enumerable: true,
        configurable: true
    });
    TimeBoundary.prototype.getAfterNearTime = function () {
        var time = this.getDateTime();
        var hour = time.getHours();
        var minute = time.getMinutes();
        var partCount = Math.ceil(minute / this.timeGap);
        // when time is the latest or more, add one hour
        if (partCount >= HOUR_MINUTES / this.timeGap) {
            hour++;
            minute = 0;
        }
        this._hour = hour;
        this._minute = (partCount * this.timeGap) % HOUR_MINUTES;
    };
    TimeBoundary.prototype.getBeforeNearTime = function () {
        var time = this.getDateTime();
        this._hour = time.getHours();
        this._minute = Math.floor(time.getMinutes() / this.timeGap) * this.timeGap;
    };
    TimeBoundary.prototype.getDateTime = function () {
        var _a;
        if (this.value instanceof Date) {
            return this.value;
        }
        var _b = getHourAndMinute((_a = this.value) !== null && _a !== void 0 ? _a : 0), hour = _b.hour, minute = _b.minute;
        var date = new Date();
        date.setHours(hour, minute, 0, 0);
        return date;
    };
    return TimeBoundary;
}());
export { TimeBoundary };
export var getRangeBoundary = function (_a) {
    var min = _a.min, max = _a.max, _b = _a.gap, gap = _b === void 0 ? TIME_GAP : _b;
    if (min !== undefined && max !== undefined) {
        var minTimestamp = getTimestamp(min);
        var maxTimestamp = getTimestamp(max);
        if (minTimestamp > maxTimestamp) {
            throw new Error("JUNO [RcTimePicker]: That boundary min " + minTimestamp + " is bigger than max " + maxTimestamp + ", please confirm your min and max range props");
        }
    }
    return {
        min: new TimeBoundary(min, 'after', gap),
        max: new TimeBoundary(max, 'before', gap),
    };
};
